import vars from 'scouting-ui/lib/scss/_exports.scss';

import type { ExportedVariables } from './types';

const variables = { ...vars } as unknown as ExportedVariables;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function generateTypes() {
  // Quick script to auto-generate the types
  const types = [
    'export interface ExportedVariables {',
    Object.entries(vars)
      .sort((a, b) => a[0].localeCompare(b[0]))
      .map(([key, value]) => `'${key}': '${value}'`),
    '}',
  ].join('\n');
  // eslint-disable-next-line no-console
  console.log({ types });
}
// generateTypes();

export default variables;
